// removed by extract-text-webpack-plugin
module.exports = {"profile":"profile__t2Dqz"};


//////////////////
// WEBPACK FOOTER
// ./routes/profile/style.css
// module id = Tv6c
// module chunks = 0